import { z } from 'zod';
import { requireAtLeastOneField } from '../zod-helpers/index.js';
import { bomItemGroupNameSchema, bomItemGroupPromptSchema } from './item-group-form.js';
// Without requireAtLeastOneField, input: {} (or { name: null, prompt: null }) would resolve to
// an all-undefined Prisma update -- a silent no-op that still returns 200.
export const updateBomItemGroupInputSchema = requireAtLeastOneField(z.object({
    name: bomItemGroupNameSchema.optional(),
    prompt: bomItemGroupPromptSchema.optional(),
}));
//# sourceMappingURL=update-item-group-input.js.map